/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
import { useModal } from '@jutro/components';
import React, { useContext, useCallback, useState, useEffect, useMemo, useRef } from 'react'
import _, { filter } from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { TFPACustomQuoteService } from 'tfpa-capability-quoteandbind-residential';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import AdditionalInsuredDetails from '../AdditionalInsuredDetails/AdditionalInsuredDetails';
import metadata from './AdditionalInsuredCoverage.metadata.json5';
import styles from '../Tables.module.scss';
import messages from '../Insureds.messages';

import { Button, DropdownSelectField } from '@jutro/legacy/components';

function AdditionalInsuredCoverage(props) {
    const { submissionVM, updateWizardData, onValueChangeAndSync, authHeader } = props;
    const AddlInsuredOccupant = 'AddlInsuredOccupant';
    const HO301CovPublicID = 'HO301';
    const LOB_CODE = 'homeowners_tfpa';
    const [insuredVM, updateInsuredVM] = useState();
    const [insuredsData, setInsuredsData] = useState([]);
    const rowIndex = useRef();
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { showAlert, showConfirm, showModal } = useModal();
    const intl = useContext(IntlContext);
    const [showInsured, updateShowInsured] = useState(false);
    const [ pcConstants, setPCConstants ] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    
    const insuredTableData = _.get(submissionVM.value, 'lobData.homeowners_tfpa.coverages.additionalInsureds_Ext')
    // const { onValidate } = useValidation('AdditionalInsuredCoverage');
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('AdditionalInsuredCoverage');

    useEffect(() => {
        insuredTableData !== undefined ? setInsuredsData(insuredTableData) : setInsuredsData([]);
    }, []);

    const editRow = (index) => {
        const newVmData = createInsured(insuredsData[index]);
        // updateInsuredVM(newVmData);
        rowIndex.current = index;
        updateInsuredVM(newVmData);
        updateShowInsured(true);
    };

    const deleteRow = (index) => {
        showConfirm({
            title: messages.wantToDelete,
            message: messages.insuredCancelMessage,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: messages.yesModal,
            cancelButtonText: messages.cancelModal,
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }
            const updatedInsuredData = insuredsData.filter((_, i) => i !== index);
            setInsuredsData(updatedInsuredData);
            submissionVM.lobData.homeowners_tfpa.coverages.additionalInsureds_Ext.value = updatedInsuredData;
            updateWizardData(submissionVM);
            onValueChangeAndSync();
            return true;
        }, _.noop)
    };

    const actionButtons = (row, index) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
                className={styles.buttons}
                type="text"
                icon="gw-edit"
                onClick={() => editRow(index)}
                aria-label="Edit Row"
            />
            <Button
                className={styles.buttons}
                type="text"
                icon="gw-delete"
                onClick={() => deleteRow(index)}
                aria-label="Delete Row"
            />
        </div>
    );
    
    let oldVMData = [];
    
    const handleValueChange = useCallback((value, path) => {
        onValueChangeAndSync(value, path);
    }, []);
    
    const saveInsureds = useCallback((updatedData) => {
        const value = _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.additionalInsureds_Ext.value');
        if (rowIndex.current !== undefined) {
            const updatedInsuredData = value.map((item, index) => index === rowIndex.current ? updatedData.value : item);
            setInsuredsData(updatedInsuredData);
            updateInsuredVM(updatedData.value);
            submissionVM.lobData.homeowners_tfpa.coverages.additionalInsureds_Ext.value = updatedInsuredData;
            updateWizardData(submissionVM);
            onValueChangeAndSync();
            rowIndex.current = undefined;
            updateShowInsured(false);
        } else {
            const newItem = _.isUndefined(value) ? [updatedData.value] : [...value, updatedData.value] ;
            setInsuredsData(newItem);
            updateInsuredVM(newItem);
            submissionVM.lobData.homeowners_tfpa.coverages.additionalInsureds_Ext.value = newItem;
            updateWizardData(submissionVM);
            onValueChangeAndSync();
            updateShowInsured(false);
        }
    }, []);
    
    const cancelInsureds = () => {
        updateInsuredVM();
        updateShowInsured(false);
    };
    
    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);
    
    const getContactName = (item) => {
        if (item.accountContactDTO) {
            const accountContact = item.accountContactDTO;
            if (accountContact.subtype === 'Company') {
                return accountContact.contactName;
            } 
            return `${accountContact.lastName}, ${accountContact.firstName}`;
            
        }
    };
    
    const getRelationship = (item) => item.relationshipToInsured;
    
    const options = [{
        name: 'Section I - Occupant',
        code: 'zckhasn0go22s49dpjvru3u725a',
        optionValue: 1,
        maxValue: 5
        }, {
        name: 'Section I and II - Occupant',
        code: 'z13g4kfabrej68ho126gbldimna',
        optionValue: 3,
        maxValue: 5
        }, {
        name: 'Section I - Non-Occupant',
        code: 'zrsg69spns6gvao2kqp0t12q558',
        optionValue: 4,
        maxValue: 5
        }, {
        name: 'Section I and II - Non-Occupant',
        code: 'zmvik0hh300acdvm42ng46cv12a',
        optionValue: 5,
        maxValue: 5
    }];
    
    const getCoverage = (item, rowId) => {
        const coverageVMPath = `lobData.homeowners_tfpa.coverages.additionalInsureds_Ext.value[${rowId}].coverages[0].terms[0].chosenTerm`;
        return (
            <DropdownSelectField
                id={`${rowId}`}
                alwaysShowPlaceholder
                availableValues={options}
                path={coverageVMPath}
                onValueChange={handleValueChange}
                value={_.get(submissionVM, `${coverageVMPath}`)}
                placeholder={{
                    id: 'tfpa.quoteandbind.contacts.additinalInsureds.coverage.placeholder',
                    defaultMessage: '-- Please Select --',
                }}
            />
        );
    };
    
    // const updatePrimaryAddressVM = useCallback((value) => {
    //     _.set(modalItem.value, 'accountContactDTO.primaryAddress', value);
    //     updateModalItem(modalItem);
    //     setPrimaryAddressVM(modalItem.accountContactDTO.primaryAddress)
    // }, [modalItem]);
    
    const updatePolicyAddressVM = useCallback((value) => {
        _.set(insuredVM.value, 'accountContactDTO.primaryAddress', value)
        updateInsuredVM(insuredVM);
        updateWizardData(submissionVM);
    }, [insuredVM, submissionVM, updateWizardData]);
    
    const createInsured = (insured, context) => {
        return viewModelService.create(insured, 'pc', 'org.tfpa.edge.capabilities.quote.submission.TFPAContactRoleDTO', context || {PAYER_ADDRESS: true});
    };
    
    const addInsured = useCallback(() => {
        const newAddlInsured = createInsured({
            tempID: EntityUtil.nextId(),
            subtype: 'PolicyAddlInsured',
            coverages: [{
                publicID: HO301CovPublicID,
                selected: true,
                updated: true,
                terms: [{
                    publicID: AddlInsuredOccupant,
                    valueType: 'Option',
                    updated: false
                }]
            }],
            accountContactDTO: {
                primaryAddress: {
                    country: 'US',
                    // mustStandardize_Ext: PCConstants.AddressStandardizationEnabled
                    }
            }
        });
        updateInsuredVM(newAddlInsured);
        updateShowInsured(true);
    }, []);


    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        AddlInsCovTable: {
            data: insuredsData,
        },
        insuredDetailSection: {
            visible: showInsured,
            newAdditionalInsured: insuredVM,
            updatePolicyAddressVM,
            authHeader,
            saveData: saveInsureds,
            cancelData: cancelInsureds,
            isInvalid: findInvalidComponent,
            isUpdated: false,
            showErrors,
        }
        
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getRelationship,
            getContactName,
            getCoverage,
            actionButtons,
            addInsured
            
        },
        resolveComponentMap: { addlInsDetails: AdditionalInsuredDetails }
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={submissionVM}
            onModelChange={updateWizardData}
            // onValueChange={writeValue}
            showErrors={showErrors}
            onValidationChange={setComponentValidation}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )
}

export default withViewModelService(AdditionalInsuredCoverage)
